import { render, staticRenderFns } from "./weixinOrder.vue?vue&type=template&id=6302777a&"
import script from "./weixinOrder.vue?vue&type=script&lang=js&"
export * from "./weixinOrder.vue?vue&type=script&lang=js&"
import style0 from "./weixinOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports